<template lang="pug">
div
  h2
    | Collaudo Dispositivi
  h4 Shelfy
  .row
    .col-12.col-md-6
      SingleDeviceTesting(color="cyan")
    .col-12.col-md-6
      SingleDeviceTesting(color="purple")
    .col-12.col-md-6
      SingleDeviceTesting(color="orange")
    .col-12.col-md-6
      SingleDeviceTesting(color="yellow")
  h4.mt-5 Smeg
  .row
    .col-12.col-md-6
      SingleDeviceTesting2(color="cyan")
    .col-12.col-md-6
      SingleDeviceTesting2(color="purple")
    .col-12.col-md-6
      SingleDeviceTesting2(color="orange")
    .col-12.col-md-6
      SingleDeviceTesting2(color="yellow")
  //- .mt-5(style="background-color: #fffde7; border-radius: 8px; padding: 16px;")
  //-   h4 Test Shipping Mode
  //-   .row
  //-     .col-12.col-md-6
  //-       SingleDeviceTesting3(color="cyan")
  //-     .col-12.col-md-6
  //-       SingleDeviceTesting3(color="purple")
  //-     .col-12.col-md-6
  //-       SingleDeviceTesting3(color="orange")
  //-     .col-12.col-md-6
  //-       SingleDeviceTesting3(color="yellow")
</template>
<script>
import SingleDeviceTesting from "./SingleDeviceTesting";
import SingleDeviceTesting2 from "./SingleDeviceTesting2";
import SingleDeviceTesting3 from "./SingleDeviceTesting3";
import ProductionService from "@/services/ProductionService";
export default {
  name: 'DeviceTesting',
  components: { SingleDeviceTesting, SingleDeviceTesting2, SingleDeviceTesting3 },
  data() {
    return {
      order: null,
      loading: false,
    }
  },
  computed: {
    id_number() { return this.$route.query?.id_number },
    commercialCode() { return this.order?.product?.commercial_code },
    isShelfy() { return this.commercialCode === 'SHL0' || this.commercialCode === 'SHL2' },
    isSmeg() { return this.commercialCode === 'KCS0' },
  },
  async mounted() {
    if (this.id_number) {
      this.loading = true
      try {
        const response = await ProductionService.getProductionOrder(this.id_number)
        this.order = response.data
      } finally {
        this.loading = false
      }
    }
  },
}
</script>
